import React from 'react';
import { getAvatarVariantUrl } from '../../utils/avatarVariants';
import './SocialPresenceRow.css';

const MAX_AVATARS = 4;

const PresenceCluster = ({ label, people, onOpen }) => {
  const ongoing = people.filter(person => person.state === 'ongoing').length;
  const visible = people.slice(0, MAX_AVATARS);
  const remaining = Math.max(0, people.length - visible.length);

  if (people.length === 0) return null;

  return (
    <button
      className="social-presence-cluster"
      type="button"
      onClick={() => onOpen(people, label)}
      aria-label={`${label}: ${people.length} people visible, ${ongoing} training now`}
    >
      <span className="social-presence-avatars" aria-hidden="true">
        {visible.map(person => (
          <span key={person.userId} className={`social-presence-avatar ${person.state === 'ongoing' ? 'ongoing' : ''}`}>
            {person.avatarUrl ? (
              <img src={getAvatarVariantUrl({ id: person.userId, avatarUrl: person.avatarUrl }, 'xs')} alt="" />
            ) : (
              (person.displayName || 'M').slice(0, 1).toUpperCase()
            )}
          </span>
        ))}
        {remaining > 0 && <span className="social-presence-avatar overflow">+{remaining}</span>}
      </span>
      <span className="social-presence-cluster-copy">
        <strong>{label}</strong>
        <span>{ongoing > 0 ? `${ongoing} training now` : `${people.length} active today`}</span>
      </span>
    </button>
  );
};

const SocialPresenceRow = ({ presence, onOpen }) => {
  const friends = presence?.friends?.people || [];
  const dojo = presence?.dojo?.people || [];
  const hasPresence = friends.length > 0 || dojo.length > 0;

  const audience = { friends, dojo };

  if (!hasPresence) return null;

  return (
    <div className="social-presence-row" role="region" aria-label="Your training circle">
      <span className="social-presence-kicker">Training circle</span>
      <div className="social-presence-clusters">
        <PresenceCluster label="Friends" people={friends} onOpen={(people, label) => onOpen(audience, people, label)} />
        <PresenceCluster label="Dojo" people={dojo} onOpen={(people, label) => onOpen(audience, people, label)} />
      </div>
    </div>
  );
};

export default SocialPresenceRow;